import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const serviceCreatorPlugin = createPlugin({
  id: 'service-creator',
  routes: {
    root: rootRouteRef,
  },
});
export const ManifestOptionsPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'ManifestOptionsPage',
    component: () =>
      import('./components/ManifestOptions').then(m => m.ManifestOptions),
    mountPoint: rootRouteRef,
  }),
);
export const ServiceCreatorPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'ServiceCreatorPage',
    component: () =>
      import('./components/ManifestGenerator').then(m => m.ManifestGenerator),
    mountPoint: rootRouteRef,
  }),
);
export const EnvironmentVariablesPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'EnvironmentVariablesPage',
    component: () =>
      import('./components/EnvironmentVariables').then(
        m => m.EnvironmentVariables,
      ),
    mountPoint: rootRouteRef,
  }),
);
export const PreviewManifestPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'PreviewPage',
    component: () =>
      import('./components/Preview').then(m => m.PreviewManifestPage),
    mountPoint: rootRouteRef,
  }),
);

export const GatewayManifestPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'GatewayManifestPage',
    component: () =>
      import('./components/GatewayManifest').then(m => m.GatewayManifest),
    mountPoint: rootRouteRef,
  }),
);
export const GatewayPreviewPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'GatewayPreviewPage',
    component: () =>
      import('./components/PreviewGatewayManifest').then(
        m => m.PreviewGatewayManifest,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const HttpRoutePage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'HttpRoutePage',
    component: () =>
      import('./components/HttpRouteManifest').then(m => m.HttpRouteManifest),
    mountPoint: rootRouteRef,
  }),
);

export const HttpRoutePreviewPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'HttpRoutePreviewPage',
    component: () =>
      import('./components/HttpRoutePreview').then(m => m.HttpRoutePreview),
    mountPoint: rootRouteRef,
  }),
);

export const CronJobGeneratorPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'CronJobGeneratorPage',
    component: () =>
      import('./components/CronJobGenerator').then(m => m.CronJobGenerator),
    mountPoint: rootRouteRef,
  }),
);

export const CronJobEnvironmentVariablesPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'CronJobEnvironmentVariablesPage',
    component: () =>
      import('./components/CronJobEnvironmentVariables').then(
        m => m.CronJobEnvironmentVariables,
      ),
    mountPoint: rootRouteRef,
  }),
);
export const CronJobPreviewPage = serviceCreatorPlugin.provide(
  createRoutableExtension({
    name: 'CronJobPreviewPage',
    component: () =>
      import('./components/CronJobManifestPreview').then(
        m => m.CronJobManifestPreview,
      ),
    mountPoint: rootRouteRef,
  }),
);
